import { HttpService } from '@/services/http.service';

export default {
    async ask(question) {
        return await HttpService.httpPost('/global/ask-a-question', question);
    },

    async prepopulate(employee) {
        return await HttpService.httpPost('/global/prepopulate-question', employee)
    },

    async answer(question) {
        return await HttpService.httpPost(`/admin/questions/${question.id}/answer`, question);
    },

    async update(question) {
        return await HttpService.httpPost(`/admin/questions/${question.id}/edit`, question);
    },
}
